import axios from "axios";

export const VF_SELECT_ENUM = {
  DSV: '{DEV}',
  SQL: '{SQL}'
};

export function getDSByName(formConfig, dsName) {
  let resultDS = null;
  if (!!dsName && !!formConfig.dataSources) {
    formConfig.dataSources.forEach(ds => {
      if (ds.uniqueName === dsName) {
        resultDS = ds;
      }
    });
  }

  return resultDS;
}

/* 用Function对象实现eval函数功能 */
const evalFn = function (fn, dsConfig = {}) {
  const f = new Function('DSV', 'VFR', "data", 'return ' + fn);
  return f(dsConfig.DSV, dsConfig.VFR, dsConfig.data);
};

/**
 * 组装axios请求配置参数
 * @param arrayObj
 * @param dsConfig
 * @returns {{}}
 */
function assembleAxiosConfig(arrayObj, dsConfig) {
  const result = {};
  if (!arrayObj || (arrayObj.length <= 0)) {
    return result;
  }

  arrayObj.map(ai => {
    if (ai.type === 'String') {
      result[ai.name] = String(ai.value);
    } else if (ai.type === 'Number') {
      result[ai.name] = Number(ai.value);
    } else if (ai.type === 'Boolean') {
      if ((ai.value.toLowerCase() === 'false') || (ai.value === '0')) {
        result[ai.name] = false;
      } else if ((ai.value.toLowerCase() === 'true') || (ai.value === '1')) {
        result[ai.name] = true;
      } else {
        result[ai.name] = null;
      }
    } else if (ai.type === 'Variable') {
      result[ai.name] = evalFn(ai.value, dsConfig);
    }
  });

  /* 需要注意：VFR.getWidgetRef()可能无法获取组件，因为组件尚未创建完成，跟数据源执行时机有关！！ */

  /* 加入如下两行日志打印代码，是为了防止编译打包时DSV、VFR参数被剔除！！ begin */
  /* DSV、VFR入参没有在本函数中直接使用到，但在eval表达式中可能被使用到，故需确保DSV、VFR参数始终存在！！ */
  // console.log('test DSV: ', DSV)
  // console.log('test VFR: ', VFR)
  /* 加入如下两行日志打印代码，是为了防止编译打包时DSV、VFR入参会被剔除！！ end */

  return result;
}
function buildRequestConfig(dataSource, dsConfig) {
  const config = {};
  if (dataSource.requestURLType === 'String') {
    config.url = dataSource.requestURL;
  } else {
    config.url = evalFn(dataSource.requestURL, dsConfig);
  }
  config.method = dataSource.requestMethod;

  config.headers = assembleAxiosConfig(dataSource.headers, dsConfig);
  config.params = assembleAxiosConfig(dataSource.params, dsConfig);
  config.data = assembleAxiosConfig(dataSource.data, dsConfig);

  const chFn = new Function('config', 'isSandbox', 'DSV', 'VFR', dataSource.configHandlerCode);
  return chFn(config, dsConfig.isSandbox, dsConfig.DSV, dsConfig.VFR);
}
export async function runDataSourceRequest(dataSource, dsConfig) {
  try {
    const requestConfig = buildRequestConfig(dataSource, dsConfig);
    const result = await axios.request(requestConfig);
    const dhFn = new Function('result', 'isSandbox', 'DSV', 'VFR', dataSource.dataHandlerCode);
    return dhFn(result, false, dsConfig.DSV, dsConfig.VFR);
  } catch (err) {
    const ehFn = new Function('error', 'isSandbox', 'DSV', '$message', 'VFR', dataSource.errorHandlerCode);
    ehFn(err, dsConfig.isSandbox, dsConfig.DSV, this.$message, dsConfig.VFR);
    console.error(err);
  }
}
